import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {UserPermissionsService} from 'src/app/services/user-permissions.service';

@Directive({
  selector: '[permissionGuard]',
})
export class PermissionGuardDirective implements OnDestroy {
  private onDestroy$ = new Subject<boolean>();
  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private userPermissionsService: UserPermissionsService,
  ) {}

  @Input() set permissionGuard(permission: string) {
    this.viewContainer.clear();
    this.userPermissionsService
      .checkUserPermissions(permission)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(isUserHavePermission => {
        if (isUserHavePermission && this.viewContainer.length < 1) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }
  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.unsubscribe();
  }
}
